import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ADD_CREATE_SURVEYS } from './constants';
import {
  AddCreateSurveysDataActionTypes,
  AddCreateSurveysError,
  AddCreateSurveysState,
  AddCreateSurveysSuccess,
} from './types';

const initialState: AddCreateSurveysState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: AddCreateSurveysDataActionTypes,
  ): AddCreateSurveysState => {
    switch (action.type) {
      case ADD_CREATE_SURVEYS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ADD_CREATE_SURVEYS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AddCreateSurveysSuccess).payload;
        break;
      }
      case ADD_CREATE_SURVEYS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AddCreateSurveysError).error;
        break;
      }
      case ADD_CREATE_SURVEYS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
